import Table from "./table-view";
export default Table;
